export default __webpack_public_path__ + "static/media/user-avatar.a7e652f4.svg";